import { Tooltip, Typography, TypographyProps } from "@material-ui/core";

interface IProps extends TypographyProps {
  }
  
  export const DataGridTypography: React.FC<IProps> = ({
    content,
    variant = "body2",
    ...rest
  }) => {
    return (
        <Tooltip title={content == null ? "" : content}>
            <Typography variant={variant} {...rest} >{content}</Typography>
        </Tooltip>
    );
  };